export const orFeaturedVideoMockData = {
  title: 'Building dreams with Paul Schumacher',
  description:
    'At the heart of Schumacher Homes is  family; ours and yours. Its a story of passion, commitment, and legacy, starting with a single home.',
  url: 'https://www.youtube.com/watch?v=2esB9jpOuzk&t=1s',
  thumbnail: {
    alt: 'Video thumbnail alt',
    src: {
      mobile: '/assets/image_card.jpg',
      tablet: '/assets/image_card.jpg',
      desktop: '/assets/image_card.jpg',
    },
  },
  buttonAriaLabel: 'play video',
  playing: true,
  muted: true,
  controls: true,
};
